import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import CampaignListParticipantsTableRow from './CampaignListParticipantsTableRow';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';
import WarningModal from '../../commonComponents/shared/WarningModal';

export default class CampaignListParticipantsTable extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = {
            selectedRecord: {},
            bypassError: false,
            removeFromActiveCampaign: false,
            showModals: {
                confirmationModal: false,
                removeFromActiveCampaignsAlertModal: false
            }
        };

        this.getTableRow = this.getTableRow.bind(this);
    }

    getTableRow(participant) {
        return <CampaignListParticipantsTableRow
            key={participant.applicantId}
            campaignListName={this.props.campaignListName}
            campaignListId={this.props.campaignListId}
            isExternalOrgCampaignList={this.props.isExternalOrgCampaignList}
            managePermission={this.props.managePermission}
            participant={participant}
            removeParticipant={participant => {
                this.setState({ selectedRecord: participant, bypassError: false, removeFromActiveCampaign: false },
                    this.toggleModal.bind(this, "confirmationModal"))
            }} />;
    }

    async removeParticipant(recipientId) {
        await this.props.removeParticipant(recipientId, this.state.bypassError, this.state.removeFromActiveCampaign);

        if (!this.props.removing.success && this.props.removing.message && this.props.removing.message.indexOf("active campaign") >= 0) {
            this.toggleModal("removeFromActiveCampaignsAlertModal");
        }
    }

    render() {
        let columns = [
            { id: 'name', title: 'Name', sortable: true },
            { id: 'phone', title: 'Phone', sortable: false },
            { id: 'address', title: 'Address', sortable: false }];
        if (this.props.isExternalOrgCampaignList) columns.push({ id: 'position', title: 'Position', sortable: false });
        if (this.props.managePermission) columns.push({ id: 'delete', title: 'Delete', sortable: false });

        return <div>
            <PaginatedTable
                name="campaign list participants"
                page={this.props.page}
                totalCount={this.props.data.totalCount}
                resultsView={this.props.resultsView}
                sort={this.props.sort}
                loading={this.props.loading}
                success={this.props.success}
                renderRow={this.getTableRow}
                columns={columns}
                records={this.props.data.records || []}
                sortData={this.props.updateTable}
                changeDataView={this.props.updateTable}
                loadData={this.props.getCampaignListParticipants} />

            <ConfirmationModal
                show={this.state.showModals.confirmationModal}
                message={this.state.selectedRecord.applicantId ? `Are you sure you want to remove ${this.state.selectedRecord.displayName || 'this participant'} from ${this.props.campaignListName || 'this campaign'} list?
                     \nThis participant will be permanently removed and will need to manually added in order to be included again.` : ''}
                close={this.toggleModal.bind(this, "confirmationModal")}
                confirm={this.removeParticipant.bind(this, this.state.selectedRecord.applicantId, null)}
                loading={this.props.removing.loading}
                success={this.props.removing.success || (this.props.removing.message && this.props.removing.message.indexOf("active campaign") >= 0)} />

            <WarningModal
                show={this.state.showModals.removeFromActiveCampaignsAlertModal}
                close={this.toggleModal.bind(this, "removeFromActiveCampaignsAlertModal")}
                message={this.props.removing.message}
                confirmationMessage={"Do you want to remove this participant from these campaign(s)?"}
                cancelText={"No"}
                continueText={"Yes"}
                cancel={() => {
                    this.setState({ bypassError: true, removeFromActiveCampaign: false }, this.removeParticipant.bind(this, this.state.selectedRecord.applicantId));
                }}
                continue={() => {
                    this.setState({ bypassError: true, removeFromActiveCampaign: true }, this.removeParticipant.bind(this, this.state.selectedRecord.applicantId));
                }} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignListDetails/CampaignListParticipantsTable.jsx